import { render, staticRenderFns } from "./UserRecordFormDialog.vue?vue&type=template&id=47507cee&"
import script from "./UserRecordFormDialog.vue?vue&type=script&lang=js&"
export * from "./UserRecordFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports